// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__DZMXV","empty":"ModalGraph_empty__30SUH"};